import React from 'react';

/* 컴포넌트 */
import CloseBtn from 'components/util/CloseModal';

const ReportCheckModal = () => {
  return (
    <>
      <CloseBtn/>

      <div className='modal-box'>
        <div className='inner'>
          <form>
            <div className='form-in'>
              <select>
                <option value='default'>-- default --</option>
              </select>
            </div>

            <div className='edit-btn'>
              <button className='cancel'>Cancel</button>
              <button className='submit' type='submit'>OK</button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default ReportCheckModal;
